import React, { ReactNode } from 'react';
import { GrCheckbox, GrCheckboxSelected } from "react-icons/gr";
import styled from '@emotion/styled';
import { useAtom } from "jotai";
import { checkedBoxesAtom } from "components/pages/Onboarding/onboardingAtom";

interface CheckboxProps {
  checked:boolean;
  onChange : (event: React.ChangeEvent<HTMLInputElement>) => void;
  children?: ReactNode;
  name:string;
  className:string;
};

const Checkbox:React.FC<CheckboxProps> = ({ className, checked, onChange, children, name }) => {
  // const [ checkboxes, setCheckboxes ] = useAtom(checkedBoxesAtom);
  return (
    <CheckboxWrapper className={className}>
      <CheckboxInput
        type="checkbox"
        checked={checked}
        onChange={onChange}
        name={name}
      />
      <CustomCheckbox 
        checked={checked}
      >
        {checked ? <GrCheckboxSelected size={20} /> : <GrCheckbox size={20}/> }
      </CustomCheckbox>
      <CheckboxLabel>{children}</CheckboxLabel>
    </CheckboxWrapper>
  );
};

export default Checkbox;


const CheckboxWrapper = styled.label`
  display: flex;
  align-items: center;
  cursor: pointer;
`;
const CheckboxInput = styled.input`
  display: none;
`;
const CustomCheckbox = styled.span<{checked: boolean}>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 4px;
`;
const CheckboxLabel = styled.span`
  margin-left: 8px;
  font-size: 14px;  
  color: #333;
`;